<template>
  <div id="app">
    <router-view keep-alive />
  </div>
</template>

<script>
export default {};
</script>
